/**
 * Canonicalize a configured language code to a BCP-47 tag for the widget's
 * `lang` attribute — the config's `en-us` becomes `en-US`. Missing, empty, or
 * structurally invalid values fall back to `en` so assistive tech always gets
 * a valid tag instead of an unparseable one.
 */
export function normalizeLang(lng?: string | null): string {
  const trimmed = lng?.trim();
  if (!trimmed) return 'en';
  try {
    return Intl.getCanonicalLocales(trimmed)[0];
  } catch {
    return 'en';
  }
}
